// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHelpIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.023-8A2.97 2.97 0 0 0 9 9.977a1 1 0 0 0 2 0c0-.544.434-.977.977-.977s.976.433.976.977a.54.54 0 0 1-.108.348c-.082.11-.214.226-.432.374l-.004.003c-.547.378-1.432 1.068-1.432 2.406a1 1 0 0 0 2 0 .56.56 0 0 1 .114-.368c.085-.114.222-.232.45-.39.546-.372 1.412-1.062 1.412-2.373A2.97 2.97 0 0 0 11.977 7"
      clipRule="evenodd"
    />
  </g>
);
export default SvgHelpIcon;
SvgHelpIcon.displayName = 'SvgHelpIcon';
